import { Component, inject } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Modal, ModalConfig, ModalType, NonPersistedModalName } from '@app/shared/models/modal.model';
import { EventManager } from '@app/shared/utils/event-manager';
import { ButtonComponent } from '@app/shared/components/button/button.component';
import { SharedModule } from '@app/shared/shared.module';
import { NavigationButtonComponent } from '@app/shared/components/navigation-button/navigation-button.component';

@Component({
  selector: 'slotcom-promo-code-expired-modal',
  templateUrl: './promo-code-expired.component.html',
  styleUrls: ['./promo-code-expired.component.scss'],
  standalone: true,
  imports: [ButtonComponent, SharedModule, NavigationButtonComponent],
})
export class PromoCodeExpiredModalComponent {
  promoCodeExpiredModalData = inject<ModalConfig>(MAT_DIALOG_DATA);
  private eventManager = inject(EventManager);
  private dialog = inject(MatDialog);

  closeModal(): void {
    this.eventManager.closeModal(
      new Modal(this.promoCodeExpiredModalData.id, ModalType.Persisted, this.promoCodeExpiredModalData)
    );
  }

  goToShop(): void {
    this.eventManager.closeModal(
      new Modal(this.promoCodeExpiredModalData.id, ModalType.Persisted, this.promoCodeExpiredModalData)
    );

    this.dialog
      .getDialogById(this.promoCodeExpiredModalData.id)
      .afterClosed()
      .subscribe(() => {
        this.eventManager.openModal(
          new Modal(NonPersistedModalName.ShopModalComponent, ModalType.View, {
            tab: 'left',
          })
        );
      });
  }
}
